import { createContext } from "react";

interface ChatContextType {
    clearChat: () => void;
}

export const ChatContext = createContext<ChatContextType>({
    clearChat: () => {}
});
